import React from 'react'
import SurveyPopup from '../../survey/SurveyPopup'

const HvLightPopup = ({ close, ...props }) => 
  <SurveyPopup close={close} surveyType="IDENTITY_LIGHT" title="Hv Light" {...props} />


export default HvLightPopup
